import Card from "components/card";
import React, { useMemo,useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { FaRegWindowClose } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import  { API_BASE_URL } from '../../../../configs/AppConfig';
import  { FILES_URL } from '../../../../configs/AppConfig';
import { message } from 'antd';
import api from "views/auth/Api";


const Challengestable = (props) => {
  const { columnsData, table, assignId ,setNew,challangePoints } = props;
  const [Open, setOpen] = useState(false);
  const [reviewPPop, setReviewPop] = useState(null);
  const [status, setStatus] = useState("");
  const [checkedReward, setCheckedReward] = useState(false);
  const [openselect, setOpenSelect] = useState(false);
  const [feedbackInfo, setFeedbackInfo] = useState(false);
  const [formInputs , setFormInputs] = useState({
          feedback:"",
        });
    const successFeedback = () => {
    message.success('Your Feedback sent successfully');
          };
const options = ["Graded", "Ungraded"];
const handleSelect = (option) => {
    setStatus(option);
    setOpenSelect(false);
    if(option !== "Graded"){
      setCheckedReward(false);
    }
  };
  console.log(checkedReward,"tableDatatableData")
const isFormValid = formInputs.feedback.trim() !== '' && status.trim() !== '';

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => table, [table]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 50;

  const viewId = (cell)=>{
    setReviewPop(cell);
    if(cell.feedback){
      setFeedbackInfo(true);
    }
      else{setOpen(true);
}
  }
  const openFile = () => {
      window.open(`${FILES_URL}${reviewPPop.presentation?.url}`, "_blank"); 
    };
    const openStl = () => {
      window.open(`${FILES_URL}${reviewPPop.stl?.url}`, "_blank"); 
    };

  
    const sendFeedback = async () => {  
       await api.post(`${API_BASE_URL}challange-feedback`,{
          feedbackText: formInputs.feedback,
          points: challangePoints,
          grade: status,
          submission: reviewPPop.id,
          assignId : assignId,
          reward: checkedReward,
          submittedBy: reviewPPop.submittedBy?.id
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  setNew(response.data);

        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }
  const doneClose = () => {
    setOpen(false)
    setOpenSelect(false);
    setCheckedReward(false);
    setStatus("");
    setFormInputs({feedback:"",
  });
  };
    const handleSubmit = (event) => {
    event.preventDefault();
    sendFeedback()
    successFeedback()
    doneClose();
    }

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <div className="mt-2 overflow-x-scroll xl:overflow-x-hidden">
        <table {...getTableProps()} className="w-full">
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index} className="trHeadTable">
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                    className="border-b border-gray-200 pr-14 pb-[10px] text-start dark:!border-navy-700"
                  >
                    <div className="flex w-full justify-between pr-10 text-xs tracking-wide text-gray-600">
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={index} className="trFeedback">
                  {row.cells.map((cell, index) => {
                    let data;
                    if (cell.column.Header === "STUDENT") {
                      data = (
                        <p className="text-sm font-bold dark:text-white">
                          {cell.value}
                        </p>
                      );
                    } 
                   else if (cell.column.Header === "SUBMITTED DATE") {
                      data = (
                        <p className="mr-[10px] text-sm font-semibold  dark:text-white">
                          {cell.value.substring(0, 10)}
                        </p>
                      );
                    } 
                    // else if (cell.column.Header === "TEAM NUMBER") {
                    //   data = (
                    //     <p className="mr-[10px] text-sm font-semibold  dark:text-white">
                    //       {cell.value}
                    //     </p>
                    //   );
                    // } 

                    else if (cell.column.Header === "STATUS") {
                      if (!cell.value) {
                        data = (
                          <p className="text-sm font-bold text-yellow-500">
                            Pending
                          </p>
                        );
                      } else if (cell.value === "Graded") {
                        data = (
                          <p className="text-sm font-bold text-green-500">
                            {cell.value}
                          </p>
                        );
                      } else if (cell.value === "Ungraded") {
                        data = (
                          <p className="text-sm font-bold text-red-500">
                            {cell.value}
                          </p>
                        );
                      }  
                     else {
                        data = (
                          <p className="text-sm font-bold dark:text-white">
                            {cell.value}
                          </p>
                        );
                     }  
                    }
                    else if (cell.column.Header === "POINTS") {
                      data = (
                        <p className="text-sm font-bold dark:text-white">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "DETAILS") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          <button className="tableViewBtn" onClick={() => {viewId(cell.row.original)}}>View</button>
                        </p>
                      );
                    }
                    return (
                      <td
                        className="pt-[14px] sm:text-[14px]"
                        {...cell.getCellProps()}
                        key={index}
                      >
                        {data}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
              { Open ? <div className="modal"> <div className="addFeedBackPop w-[350px]">
                <div className="addFeedBack"> <span className="Review-submit" >Review Submission</span>
                  <button id="popIcon" onClick={()=>{doneClose()}}>
                  <FaRegWindowClose className="w-full h-full	"/>
                </button> </div>
                <div className="fileReviews" onClick={() => openFile(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment PDF </span>
                 </div>
                <div className="fileReviews" onClick={() => openStl(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment STL </span>
                 </div>
                <form className="feedbackForm">
                  <div className="feedbackInpts">
                    <label htmlFor="feedbackText">Feedback</label>
                    <textarea type="text" className="inputWidthFeed" id="feedbackText" value={formInputs.feedback} placeholder="Enter your feedback here..." 
                    onChange={(e) =>setFormInputs({...formInputs, feedback: e.target.value})}/>
                  </div>

                    <div className="feedbackInpts">
                    <label htmlFor="grade">Grade</label> 
        {/* Dropdown Box */}
      <div style={{ position: "relative", width: "100%" }}>
      <div
        onClick={() => setOpenSelect(!openselect)}
        style={{
          width: "100%",
          height: "44px",
          background: "#FFFFFF",
          border: "1px solid #6C5CE7",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 12px",
          cursor: "pointer",
          color: status ? "black" : "#999",
          userSelect: "none",
        }}
      >
        {status || "Select Grade"}

        <span style={{ color: "#573995", fontSize: "14px" }}>
          {openselect ? "▲" : "▼"}
        </span>
      </div>

      {/* Dropdown Menu */}
      {openselect && (
        <div
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            width: "100%",
            background: "#FFFFFF",
            border: "1px solid #6C5CE7",
            borderRadius: "8px",
            zIndex: 99,
            overflow: "hidden",
          }}
        >
          {options.map((opt, index) => (
            <div
              key={index}
              onClick={() => handleSelect(opt)}
              style={{
                padding: "10px",
                color: "#000",
                cursor: "pointer",
                transition: "0.2s",
                background: status === opt ? "#1f29373d" : "transparent",
              }}
              onMouseEnter={(e) =>
                (e.target.style.background = "#1f29373d")
              }
              onMouseLeave={(e) =>
                (e.target.style.background =
                  status === opt ? "#1f29373d" : "transparent")
              }
            >
              {opt}
            </div>
          ))}
        </div>
      )}
                  </div>
                  </div>
                 {status === "Graded" ? <div className="pointsAwarded">
                    <label htmlFor="pointsAwarded">Points Awarded</label> 
                    {/* <input type="number" className="inputWidthFeed" id="pointsAwarded" value={formInputs.points}  placeholder="Enter points awarded" 
                    onChange={(e) =>setFormInputs({...formInputs, points: e.target.value})}/> */}
                  <input type="checkbox" onChange={() => setCheckedReward(!checkedReward)} checked={checkedReward} className="checkTD" />
                  </div> : null}

                <button className="sendFeedBackBtn" onClick={handleSubmit} disabled={!isFormValid}> Send Feedback </button>  
                </form>
                </div>
                  </div> : null}

        { feedbackInfo ? <div className="modal"> <div className="addFeedBackPop w-[450px]">
                <div className="addFeedBack"> 
                  <span className="Review-grade" 
                style={{
                background: reviewPPop.feedback.status === "Graded" ? "#62CA4E" : "#f53939",
              }} >{reviewPPop.feedback.status}</span>
                  <button id="popIcon" onClick={()=>{setFeedbackInfo(false)}}>
                  <FaRegWindowClose className="w-full h-full	"/>
                </button> </div>
                  <div className="feedbackInpts">
                    <span className="feedbackSpan">Feedback</span>
                    <div className="feedbackDev">
                      {reviewPPop.feedback.feedbackText}
                    </div>
                  </div>
                  <div className="feedbackSpan">
                    <span>Submitted Files</span>
                  </div>
                <div className="fileReviews" onClick={() => openFile(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment PDF </span> 
                </div>
              <div className="fileReviews" onClick={() => openStl(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment STL </span>
                 </div>

                </div>
                  </div> : null}
      
    </Card>
  );
};

export default Challengestable;
